<template>
    <div class="state-block">
        <h3>{{ title }}</h3>
        <p style="margin: 0">{{ message }}</p>
    </div>
</template>

<script setup>
defineProps({
    title: {type: String, required: true},
    message: {type: String, required: true},
});
</script>
